module.exports = __webpack_public_path__ + "img/border_trapezoid.898e70f6.svg";